import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Loading from '../../Loading/Loading';
import SimpleDialog from '../SimpleDialog/SimpleDialog';
import MarkdownEditor from '../../ui/inputs/MarkdownEditor/MarkdownEditor';
import styled from 'styled-components';
import { getInvitationBody } from '../../../store/recruitment/sagas';

interface Props {
  id: number;
  onClose: () => void;
}

const InvitationBodyDialog: React.FC<Props> = ({ id, onClose }) => {
  const { t, i18n } = useTranslation();
  const [content, setContent] = React.useState<string>('');

  useEffect(() => {
    getInvitationBody(id).then((response) => {
      if (response.type === 'ok') {
        setContent(response.value.data.body);
      }
    });
  }, [id]);

  return (
    <SimpleDialog title={t('View body')} open={true} handleClose={onClose} cancelButtonText={t('Close')}>
      <StyledSimpleDialog>
        {content ? <MarkdownEditor defaultValue={content} editable={false} /> : <Loading compact />}
      </StyledSimpleDialog>
    </SimpleDialog>
  );
};

const StyledSimpleDialog = styled.div`
  > div {
    width: 35rem;
  }
  .k-editor .k-editor-content {
    /* target the content area */
    height: 25rem;
  }
  .k-editor-content > .k-iframe {
    height: 100% !important;
  }
`;

export default InvitationBodyDialog;
